import React from 'react';
import {
  StyleSheet,
  View,
  Image,
  ViewStyle,
  ImageStyle,
  StyleProp,
} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import colors from 'theme/Colors';
import {useResponsiveStyles} from 'hooks/useResponsiveStyles';
import {mobileViewportWidth} from 'constants/DefaultValues';
import {spacing} from 'theme/Units';

type propsTypes = Readonly<{style?: StyleProp<ViewStyle>}>;
export function GradientWithLogo(props: propsTypes) {
  const {style: overrideStyles} = props;
  const styles = useResponsiveStyles<styleType>(baseStyles, responsive);
  return (
    <View style={[styles.imageContainer, overrideStyles]}>
      {/* some comments to break duplicacy */}
      <LinearGradient
        end={{x: 1, y: 1}}
        style={styles.gradient}
        start={{x: 0, y: 0}}
        colors={[
          `${colors.palette.brandPink}33`,
          `${colors.palette.brandBlue}33`,
        ]}>
        <Image
          resizeMode="contain"
          source={require('assets/images/logo_black@2x.png')}
          style={styles.image}
        />
      </LinearGradient>
    </View>
  );
}

type styleType = {
  imageContainer: ViewStyle;
  gradient: ViewStyle;
  image: ImageStyle;
};
const baseStyles: styleType = StyleSheet.create({
  imageContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '60%',
    height: '100%',
  },
  gradient: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
});

const responsive: Record<number, Partial<styleType>> = {
  [mobileViewportWidth]: {
    image: {
      paddingBottom: spacing['8'],
      height: "80%",
    },
    gradient: {
      justifyContent: 'flex-start',
    }
  },
};
